<script lang="ts">
	interface Props {
		strokeWidth?: number;
		className?: string;
	}

	let { strokeWidth = 1, className = '' }: Props = $props();
</script>

<div class={className}>
	<svg
		viewBox="0 0 32 32"
		enable-background="new 0 0 32 32"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		fill="currentColor"
		stroke="currentColor"
		stroke-width={strokeWidth}
	>
		<g id="XMLID_1949_">
			<g id="XMLID_2132_">
				<path
					d="M12,14.521h2c0,0.55-0.45,1-1,1S12,15.07,12,14.521z"
					fill="currentColor"
					id="XMLID_2137_"
				></path>
				<path
					d="M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z "
					fill="currentColor"
					id="XMLID_2134_"
				></path>
				<path
					d="M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z"
					fill="currentColor"
					id="XMLID_2133_"
				></path>
			</g>
		</g>
		<g id="XMLID_1838_">
			<g id="XMLID_4088_">
				<line
					fill="none"
					id="XMLID_4094_"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					x1="23.43"
					x2="21.214"
					y1="23.401"
					y2="21.186"
				></line>
				<path
					d=" M29.914,27.086l-3.5-3.5c-0.756-0.756-2.072-0.756-2.828,0C23.208,23.964,23,24.466,23,25s0.208,1.036,0.586,1.414l3.5,3.5 c0.378,0.378,0.88,0.586,1.414,0.586s1.036-0.208,1.414-0.586S30.5,29.034,30.5,28.5S30.292,27.464,29.914,27.086z"
					fill="none"
					id="XMLID_4093_"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
				></path>
				<circle
					cx="13"
					cy="13"
					fill="none"
					id="XMLID_4092_"
					r="11.5"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
				></circle>
				<path
					d=" M12,14.521h2c0,0.55-0.45,1-1,1S12,15.07,12,14.521z"
					fill="none"
					id="XMLID_4091_"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
				></path>
				<path
					d=" M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z"
					fill="none"
					id="XMLID_4090_"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
				></path>
				<path
					d=" M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z"
					fill="none"
					id="XMLID_4089_"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
				></path>
			</g>
			<g id="XMLID_3004_">
				<line
					fill="none"
					id="XMLID_4087_"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					x1="23.43"
					x2="21.214"
					y1="23.401"
					y2="21.186"
				></line>
				<path
					d=" M29.914,27.086l-3.5-3.5c-0.756-0.756-2.072-0.756-2.828,0C23.208,23.964,23,24.466,23,25s0.208,1.036,0.586,1.414l3.5,3.5 c0.378,0.378,0.88,0.586,1.414,0.586s1.036-0.208,1.414-0.586S30.5,29.034,30.5,28.5S30.292,27.464,29.914,27.086z"
					fill="none"
					id="XMLID_3009_"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
				></path>
				<circle
					cx="13"
					cy="13"
					fill="none"
					id="XMLID_3008_"
					r="11.5"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
				></circle>
				<path
					d=" M12,14.521h2c0,0.55-0.45,1-1,1S12,15.07,12,14.521z"
					fill="none"
					id="XMLID_3007_"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
				></path>
				<path
					d=" M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z"
					fill="none"
					id="XMLID_3006_"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
				></path>
				<path
					d=" M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z"
					fill="none"
					id="XMLID_3005_"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
				></path>
			</g>
		</g>
	</svg>
</div>
